package com.eladfinish.bible.contest.usecase

import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfig
import com.eladfinish.bible.contest.repository.remoteConfig.RemoteConfigRepository
import kotlinx.serialization.InternalSerializationApi
import kotlinx.serialization.KSerializer
import kotlinx.serialization.serializer

class GetRemoteConfigObjectUseCase(
    val remoteConfigRepository: RemoteConfigRepository,
) {

    @OptIn(InternalSerializationApi::class)
    inline operator fun <reified T : Any> invoke(
        remoteConfig: RemoteConfig,
        serializer: KSerializer<T> = T::class.serializer(),
    ): T? {
        return remoteConfigRepository.get(remoteConfig, serializer)
    }
}
